<template>
  <div class="rec-products-view">
    <router-link to="/plan/tools" class="back-link">
      <Flexy><img :src="ArrowRightIcon" /> <p>{{t('Shopping List')}}</p></Flexy>
    </router-link>
    <router-link to="/plan/products">
    <small>{{t('shopping-list-paragraph')}}</small>
    </router-link>
    <div v-for="(items, category) in productsByCategory" class="category">
      <div class="flexy">
        <h2 style="flex: 1">{{t(category)}}</h2>
        <button class="btn tag-btn" @click="toggleCategory(category)">{{t(isHidden(category)?"+":"-")}}</button>
      </div>
      <div class="category-inner" v-if="!isHidden(category)">
        <div v-for="item in items" class="product">
          <div class="flexy">
            <img v-if="item.image" :src="item.image" />
<!--            <div v-else class="no-image"></div>-->
            <div class="title">{{item.name}}</div>
          </div>
         <div class="description">{{item.description}}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Fito from "@/lib/fito";
import t from "@/lib/Locale";
import Flexy from "@/components/ui/widgets/Flexy.vue";
import ArrowRightIcon from '@/assets/icons/arrow-right.svg';
export default {
  name: 'RecommendedProducts',
  components: {Flexy},
  data() {
    return {
      ArrowRightIcon,
      loadedProducts: [],
      hiddenCategories: [],
    }
  },
  mounted() {
    this.loadProducts();
  },
  computed : {
    productsByCategory() {
      return this.loadedProducts.reduce((acc, product) => {
        if (!acc[product.category]) {
          acc[product.category] = [];
        }
        acc[product.category].push(product);
        return acc;
      }, {});

    }
  },
  methods: {
    t,
    async loadProducts() {
      const sheet = await Fito().loadSheet('shopping-list');
      for (let item of sheet) {
        this.loadedProducts.push({
          name: item[0],
          description: item[1],
          category: item[2],
          image: item[3],
        })
      }
    },
    toggleCategory(category) {
      if (this.hiddenCategories.includes(category)) {
        this.hiddenCategories = this.hiddenCategories.filter(c => c !== category);
      } else {
        this.hiddenCategories.push(category);
      }
    },
    isHidden(category) {
      return this.hiddenCategories.includes(category);
    }
  },
}
</script>